import * as actionTypes from '../../store/actions/types.js'
import { persistLoginTokens } from './persistLoginTokens.ts'
import { buildReduxAccessPayloadFromAccessToken } from './sessionAccessPayload.ts'

export type SessionDispatchFn = (action: {
  type: string
  payload: unknown
}) => unknown

export const applyAccessTokenToSession = (
  dispatch: SessionDispatchFn,
  access_token: string
): void => {
  persistLoginTokens({ access_token })
  dispatch({
    type: actionTypes.SET_ACCESS,
    payload: buildReduxAccessPayloadFromAccessToken(access_token),
  })
}
